import React from "react";

export function useAutocompleteKeyboard({ suggestions, showSuggestions, setShowSuggestions, onSelect, listRef }) {
  const [hoveredIndex, setHoveredIndex] = React.useState(null);

  React.useEffect(() => {
    setHoveredIndex(null);
  }, [suggestions]);

  React.useEffect(() => {
    if (hoveredIndex === null || !listRef?.current) return;
    const items = listRef.current.querySelectorAll('[role="option"]');
    if (items[hoveredIndex]) {
      items[hoveredIndex].scrollIntoView({ block: "nearest" });
    }
  }, [hoveredIndex]);

  function handleKeyDown(e) {
    if (!showSuggestions || suggestions.length === 0) {
      if (e.key === "Escape") setShowSuggestions(false);
      return;
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHoveredIndex((prev) => (prev === null ? 0 : Math.min(prev + 1, suggestions.length - 1)));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHoveredIndex((prev) => (prev === null || prev === 0 ? null : prev - 1));
    } else if (e.key === "Enter" && hoveredIndex !== null) {
      e.preventDefault();
      onSelect(suggestions[hoveredIndex]);
    } else if (e.key === "Escape" || e.key === "Tab") {
      setShowSuggestions(false);
      setHoveredIndex(null);
    }
  }

  return { hoveredIndex, setHoveredIndex, handleKeyDown };
}
